const SET_USER = "SET_USER";

const ROLE_SUPER_ADMINISTRATOR = "super-administrator";
const ROLE_ADMINISTRATOR = "administrator";
const ROLE_USER = "user";

const NAMESPACE_GLOBAL = "global";
const NAMESPACE_SOUTH_AFRICA = "south-africa";
const NAMESPACE_KUWAIT = "kuwait";
const NAMESPACE_KENYA = "kenya";

const debug = require("debug")("debug");

export const user = {
  state() {
    return {
      id: null,
      email: null,
      status: null,
      role: null,
      namespace: null,
    };
  },
  getters: {
    getLoggedInUserEmail(state) {
      return state.email || null;
    },
    isSuperAdministrator(state) {
      return state.role === ROLE_SUPER_ADMINISTRATOR;
    },
    isAdministrator(state) {
      return (
        state.role === ROLE_ADMINISTRATOR ||
        state.role === ROLE_SUPER_ADMINISTRATOR
      );
    },
    isUser(state) {
      return (
        state.role === ROLE_USER ||
        state.role === ROLE_ADMINISTRATOR ||
        state.role === ROLE_SUPER_ADMINISTRATOR
      );
    },
    isSouthAfrica(state) {
      return (
        state.namespace === NAMESPACE_SOUTH_AFRICA ||
        state.namespace === NAMESPACE_GLOBAL
      );
    },
    isKuwait(state) {
      return (
        state.namespace === NAMESPACE_KUWAIT ||
        state.namespace === NAMESPACE_GLOBAL
      );
    },
    isKenya(state) {
      return (
        state.namespace === NAMESPACE_KENYA ||
        state.namespace === NAMESPACE_GLOBAL
      );
    },
  },
  mutations: {
    [SET_USER](state, { id, email, namespace, role, status }) {
      debug({ user: user });
      state.id = id;
      state.email = email;
      state.namespace = namespace;
      state.role = role;
      state.status = status;
    },
  },
  actions: {
    setUser({ commit }, user) {
      commit(SET_USER, user);
    },
  },
};
